var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"company-profile d-flex flex-column"},[_c('page-title',{staticClass:"mb-4",attrs:{"title":_vm.$t('company_profile'),"sub-title":_vm.$t('company_profile_sub_title')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }